import { Component, OnInit, Input, ViewChild, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { JobServicesService } from '../../services/job-services.service';
import { RoleServicesService } from '../../services/role-services.service';
import { GlobalServicesService } from '../../services/global-services.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { environment } from 'src/environments/environment';
import { SharedServicesService } from 'src/app/services/shared-services.service';
// import * as locationList from '../../../assets/Json/locationsList.json'
import { nanoid } from 'nanoid'
import { CountryStateCityService } from 'src/app/services/country-state-city.service';

declare let tinymce: any;

@Component({
    selector: 'app-role-add',
    templateUrl: './role-add.component.html',
    styleUrls: ['./role-add.component.css'],
    providers: [MessageService],
    standalone: false
})
export class RoleAddComponent implements OnInit, OnChanges {
  tinymce_api_key = environment.HOST.TINYMCE_API_KEY;
  @ViewChild('countryDiv') countryDiv: any;
  @ViewChild('stateDiv') stateDiv: any;
  @ViewChild('cityDiv') cityDiv: any;
  @ViewChild('roleTypeDiv') roleTypeDiv: any;
  @ViewChild('remoteDiv') remoteDiv: any;
  @ViewChild('hiringManagerDiv') hiringManagerDiv: any;
  @Input() data: any;
  @Output() closeAddRole = new EventEmitter<boolean>();
  @Output() roleUpdated: EventEmitter<void> = new EventEmitter<void>();
  @Input() clearData: boolean = false;
  isUpdate: boolean = false;
  title = 'formarray';
  orderForm!: FormGroup;
  locationInformation!: FormArray;
  selectedRoleType: string = '';
  selectedRemote: string = '';
  initialized = false;
  roleTypeList: any;
  workModeList = [
    { label: 'Remote', value: 'Remote' },
    { label: 'In Office', value: 'Office' },
    { label: 'Hybrid', value: 'Hybrid' },
  ];
  countries: any[] = [];
  locationOptions: any[] = [];

  selectedCountries: any[] = [];
  selectedStates: any[] = [];
  selectedCities: any[] = [];  
  jsonData: any = {};
  resume: File[] = [];
  mediaFile: File[] = [];
  mediaBase64: any = '';
  attachmentName: any = null;
  loadingSpinner: boolean = true;
  clicked: boolean = false;
  hiringManager: any = [];
  locationList: any = [];
  roleHeader: string = '';
  saveStatus: string = '';
  roleDescriptionData: string = '';
  showEditor: boolean = false;
  saveBtnLoading: boolean = false;
  companyId: string = '';
  uploadingFile: boolean = false;
  filteredCountries: any[] = [];
  countrySearchTerm: string = '';
  filteredStates: any[][] = [];
  filteredCities: any[][] = [];
  filteredHiringManagers: any[] = [];
  stateSearchTerm: string = '';
  citySearchTerm: string = '';
  hiringManagerSearchTerm: string = '';

  attachment: any;

  constructor(
    private formBuilder: FormBuilder,
    private jobService: JobServicesService,
    private messageService: MessageService,
    private roleService: RoleServicesService,
    private globalService: GlobalServicesService,
    private fileUploadService: FileUploadService,
    private countryStateCityService: CountryStateCityService,
    private sharedService: SharedServicesService
  ) { }

  initializeData() {
    if (this.initialized) return;
    this.initialized = true;
    this.loadCountryStateCityData();
    this.getHiringMangerAndRoleType();
    (this.data && this.data.isUpdate) ? this.updateAction() : this.saveAction();
  }
  ngOnInit(): void {
    this.companyId = localStorage.getItem('companyUUID') ?? '';
    this.globalService.removeScript();
    this.hiringManager = [];
    this.orderForm = new FormGroup({
      roleName: new FormControl('', Validators.required),
      requirement: new FormControl(''),
      roleType: new FormControl('', Validators.required),
      remoteJob: new FormControl('', Validators.required),
      roleDescription: new FormControl('', [Validators.required, Validators.minLength(250)]),
      attachment: new FormControl(''),
      locationInformation: new FormArray([]),
    });
    this.locationInformation = this.orderForm.get(
      'locationInformation'
    ) as FormArray;
    (this.data && this.data.isUpdate) ? this.updateAction() : this.saveAction();
    this.loadTinyMce();
    this.initializeData();
  }
  loadCountryStateCityData() {
    this.countryStateCityService.getCountryStateCityData().subscribe(data => {
      this.jsonData = data;
      this.loadCountries();
    });
  }
   loadCountries() {
    this.countries = Object.keys(this.jsonData).map(country => ({
      label: country,
      value: country
    }));
    this.filteredCountries = [...this.countries];
  }
  filterCountries(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredCountries = this.countries.filter(country => 
      country.label.toLowerCase().includes(searchTerm)
    );
  }
  filterStates(event: any, index: number) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredStates[index] = this.locationOptions[index].states.filter((state: any) => 
      state.label.toLowerCase().includes(searchTerm)
    );
  }

  filterCities(event: any, index: number) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredCities[index] = this.locationOptions[index].cities.filter((city: any) => 
      city.label.toLowerCase().includes(searchTerm)
    );
  }

  filterHiringManagers(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredHiringManagers = this.hiringManager.filter((manager: any) => 
      manager.name.toLowerCase().includes(searchTerm)
    );
  }

  onCountryChange(country: any, index: number) {
    this.selectedStates[index] = null;
    this.selectedCities[index] = null;
    this.selectedCountries[index] = country;
    if (country) {
      this.locationOptions[index].states = Object.keys(this.jsonData[country]).map(state => ({
        label: state,
        value: state
      }));
      this.locationOptions[index].cities = [];
      (this.locationInformation.at(index) as FormGroup).get('state')!.setValue('');
      (this.locationInformation.at(index) as FormGroup).get('city')!.setValue('');
    } else {
      this.locationOptions[index].states = [];
      this.locationOptions[index].cities = [];
      (this.locationInformation.at(index) as FormGroup).get('state')!.setValue('');
      (this.locationInformation.at(index) as FormGroup).get('city')!.setValue('');
    }
  }

  onStateChange(state: any, index: number) {
    this.selectedCities[index] = null;
    this.selectedStates[index] = state;
    const country = this.selectedCountries[index];
    if (state && country) {
      this.locationOptions[index].cities = (this.jsonData[country][state] || []).map((city: any) => ({
        label: city,
        value: city
      }));
      (this.locationInformation.at(index) as FormGroup).get('city')!.setValue('');
    } else {
      this.locationOptions[index].cities = [];
      (this.locationInformation.at(index) as FormGroup).get('city')!.setValue('');
    }
  }
  onClickStateChange(state: any, index: number){
    this.selectedStates[index] = state;
    (this.locationInformation.at(index) as FormGroup).get('state')!.setValue(state);
    this.onStateChange(state, index);
  }
  onClickCountryChange(state: any, index: number){
    this.selectedCountries[index] = state;
    (this.locationInformation.at(index) as FormGroup).get('country')!.setValue(state);
    this.onCountryChange(state, index);
  }
  onClickCityChange(state: any, index: number){
    this.selectedCities[index] = state;
    (this.locationInformation.at(index) as FormGroup).get('city')!.setValue(state);
  }
ngOnChanges() {
  const fullAttachmentPath = this.data?.attachment || '';
  const extractedFileName = fullAttachmentPath.split('/').pop();
  if (extractedFileName) {
    const blob: any = new Blob([""], { type: 'application/pdf' });
    blob["lastModifiedDate"] = "";
    blob["name"] = extractedFileName;
    this.mediaFile = [blob];
    this.attachmentName = extractedFileName;
  } else {
    this.mediaFile = [];
    this.attachmentName = null;
  }    
  if (this.data) {
    this.isUpdate = this.data.isUpdate || false;
  }
}
  async getHiringMangerAndRoleType() {
    this.loadingSpinner = true;
    let apiMethod = this.roleService.getJobRolesFormDataFastApi(); 
    apiMethod.subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          // this.hiringManager = response.body.hire_managers.map((element: any) => ({
          //   name: `${element.first_name} ${element.last_name}`,
          //   id: element.id
          // }));
          this.roleTypeList = response.body.role_types.map((element: any) => ({
            label: element.name,
            value: element.id
          }));
          // this.filteredHiringManagers = [...this.hiringManager];
        }
      },
      error: (_err) => {
        this.loadingSpinner = false;
      },
      complete: () => {
        this.loadingSpinner = false; 
      }
    });
  }
  async getLocations() {
    this.loadingSpinner = true;
    let apiMethod = this.globalService.getJobRolesLocationFastApi();
    apiMethod.subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.locationList = response.body.locations;
        }
      },
      error: (_err) => {
        this.loadingSpinner = false;
      },
      complete: () => {
        this.loadingSpinner = false;
      }
    });
  }
  updateAction() {
    this.roleHeader = 'Update Role';
    this.saveStatus = 'Update';
  }

  saveAction() {
    this.roleHeader = 'Create New Role';
    this.saveStatus = 'Save';
  }

  async setRoleDetails(data: any) {
    this.isUpdate = true;
    
    if (!this.roleTypeList) {
      await new Promise<void>((resolve) => {
        const subscription = this.roleService.getJobRolesFormDataFastApi().subscribe({
          next: (response: any) => {
            if (response.status === 200) {
              this.roleTypeList = response.body.role_types.map((element: any) => ({
                label: element.name,
                value: element.id
              }));
              // this.hiringManager = response.body.hire_managers.map((element: any) => ({
              //   name: `${element.first_name} ${element.last_name}`,
              //   id: element.id
              // }));
              // this.filteredHiringManagers = [...this.hiringManager];
              resolve();
            }
          },
          error: (_err) => {
            console.error('Error loading role types:', _err);
            resolve();
          },
          complete: () => {
            subscription.unsubscribe();
          }
        });
      });
    }

    if (data && data.locations && data.role_type && data.name) {
      this.populateRoleForm(data);
      return;
    }

    try {
      const response = await this.roleService.getSpecificJobRolesFastApi(data.id.toString()).toPromise();
      if (response?.status === 200 && response.body) {
        this.populateRoleForm(response.body);
      }
    } catch (error) {
      console.error('Error fetching role data:', error);
    }
  }

  populateRoleForm(data: any): void {
    const roleType = data.role_type && this.roleTypeList ? 
      this.roleTypeList.find((mode: any) => mode.value === data.role_type?.id)?.label || 
      data.role_type?.name : '';

    const roleDetails = {
      roleName: data.name || '',
      requirement: data.requirement || '',
      roleType: roleType,
      remoteJob: this.workModeList?.find(mode => mode.value === data.work_mode)?.label || data.work_mode || '',
      roleDescription: data.description || '',
      attachment: data.attachment || '',
    };

    this.attachmentName = data.attachment ? data.attachment.split('/').pop() : null;
    this.orderForm.patchValue(roleDetails);
    this.selectedRoleType = roleDetails.roleType;

    if (data.description && tinymce.activeEditor) {
      tinymce.activeEditor.setContent(data.description);
    }

    this.locationInformation.clear();
    this.locationOptions = [];
    this.selectedCountries = [];
    this.selectedStates = [];
    this.selectedCities = [];

    const locations = Array.isArray(data.locations) ? data.locations : [];
    locations.forEach((each: any, index: number) => {
      this.locationInformation.push(
        this.formBuilder.group({
          location: each.location || '',
          country: each.country || '',
          state: each.state || '',
          city: each.city || '',
          hiringManager: each.hire_manager_id 
            ? this.hiringManager?.find((mode: any) => mode.id === each.hire_manager_id)?.name 
            : '',
          hiringManagerId: each.hire_manager_id || '',
          businessUnit: each.business_unit || '',
          openings: each.opening || 0,
          maximumApplicants: each.max_applicant || 0,
          maleDiversity: each.diversity_male || 0,
          femaleDiversity: each.diversity_female || 0,
          otherDiversity: each.diversity_other || 0,
        })
      );

      this.locationOptions.push({ states: [], cities: [] });
      this.selectedCountries.push(each.country || null);
      this.selectedStates.push(each.state || null);
      this.selectedCities.push(each.city || null);

      if (each.country && this.jsonData[each.country]) {
        this.locationOptions[index].states = Object.keys(this.jsonData[each.country]).map(state => ({
          label: state,
          value: state,
        }));
        
        if (each.state && this.jsonData[each.country][each.state]) {
          this.locationOptions[index].cities = this.jsonData[each.country][each.state].map((city: string) => ({
            label: city,
            value: city,
          }));
        }
      }
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      location: new FormControl('',),
      country: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      // For now hiring manager is commented out from event
      // hiringManager: new FormControl('', Validators.required),
      // hiringManagerId: new FormControl('', Validators.required),
      businessUnit: new FormControl('', Validators.required),
      openings: '',
      maximumApplicants: '',
      maleDiversity: '',
      femaleDiversity: '',
      otherDiversity: ''
    });
  }

  addItem(): void {
    this.locationInformation.push(this.createItem());
    this.locationOptions.push({ states: [], cities: [] });
    this.selectedCountries.push(null);
    this.selectedStates.push(null);
    this.selectedCities.push(null);
  }

  get formData() {
    return <FormArray>this.orderForm.get('locationInformation');
  }

  getPlainTextLength(htmlContent: string): number {
    if (!htmlContent) return 0;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText.trim().length;
  }

  checkMandatory(data: any) {
    let success = true;
    const roleDescriptionLength = this.getPlainTextLength(data.roleDescription || '');
    const hasRoleDescription = data.roleDescription && roleDescriptionLength > 0;
    
    if (data.roleName && data.roleType && hasRoleDescription && roleDescriptionLength >= 250) {
      data.locationInformation.forEach((each: any) => {
      if (!(each?.city?.length && each?.country?.length && each?.state?.length && each?.businessUnit?.length)) {
        success = false;
      }
      });
    } else {
      success = false;
    }
    return success;
  }

  submitItem() {
    this.clicked = true;
    Object.keys(this.orderForm.controls).forEach(key => {
      const control = this.orderForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
    this.locationInformation.controls.forEach((locationControl, index) => {
      Object.keys((locationControl as FormGroup).controls).forEach(key => {
        const control = (locationControl as FormGroup).get(key);
        if (control) {
          control.markAsTouched();
        }
      });
    });
    const fieldsToCheck = ['roleName', 'requirement'];
    if (this.sharedService.hasSecurityViolations(this.orderForm, fieldsToCheck)) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      return;
    }
    let hasLocationSecurityViolations = false;
    this.locationInformation.controls.forEach((locationControl, index) => {
      const businessUnitValue = (locationControl as FormGroup).get('businessUnit')?.value;
      if (businessUnitValue && this.sharedService.hasSingleInputViolation(businessUnitValue)) {
        hasLocationSecurityViolations = true;
      }
    });

    if (hasLocationSecurityViolations) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      return;
    }
    this.orderForm.value.owner = localStorage.getItem('owner');
    this.orderForm.value.attachment = this.mediaFile[0] ? this.attachmentName : null;
    const roleDescriptionContent = tinymce.get(0).getContent()
      ? tinymce.get(0).getContent()
      : null;
    this.orderForm.value.roleDescription = roleDescriptionContent;
  
    const roleDescriptionLength = this.getPlainTextLength(roleDescriptionContent || '');
    const hasRoleDescription = roleDescriptionContent && roleDescriptionLength > 0;
    
    if (hasRoleDescription && roleDescriptionLength < 250) {
      this.clicked = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Failed',
        detail: 'Role description must be at least 250 characters',
      });
      return;
    }
  
    if (!this.checkMandatory(this.orderForm.value)) {
      this.clicked = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Failed',
        detail: 'Please Fill Mandatory Fields',
      });
      return;
    }
      const invalidEntries = this.orderForm.value.locationInformation.filter(
      (loc: any) =>
        loc.openings !== null &&
        loc.maximumApplicants !== null &&
        +loc.openings > +loc.maximumApplicants
    );
    if (invalidEntries.length > 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Openings cannot be greater than Maximum Applicants',
      });
      return;
    }  
    if (this.isUpdate) {
      this.updateRoles();
    } else {
      this.addRoles();
    }
  }

  updateRoles() {
    this.saveBtnLoading = true;
    let secureFormValue = this.sharedService.getSecurePayload(this.orderForm.value);    
    const updateJobRolePayload = {
      name: secureFormValue.roleName,
      role_type_id: this.roleTypeList.find((mode:any) => mode.label === this.orderForm.value.roleType)?.value,
      requirement: secureFormValue.requirement,
      description: (this.orderForm.value.roleDescription || '')
        .replace(/^[\s\n\r]+/, '')
        .replace(/[\s\n\r]+$/, '')
        .replace(/^\s*(<p>&nbsp;<\/p>|\s)*/, '')
        .trim(),
      attachment: this.orderForm.value.attachment,
      work_mode: this.workModeList.find(mode => mode.label === this.orderForm.value.remoteJob)?.value,
      locations: this.orderForm.value.locationInformation.map((each: any) => ({
        country: each.country ? each.country : '',
        state: each.state ? each.state  : '',
        city: each.city ? Array.isArray(each.city) ? each.city : [each.city] : [],
        hire_manager_id: each.hiringManagerId,
        business_unit: this.sharedService.sanitizeInput(each.businessUnit),
        opening: each.openings ? each.openings : 0,
        max_applicant: each.maximumApplicants || 0,
        diversity_male: each.maleDiversity || 0,
        diversity_female: each.femaleDiversity || 0,
        diversity_other: each.otherDiversity || 0,
      })),
    };
    this.roleService.updateJobRolesFastApi(this.data.id, updateJobRolePayload).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          setTimeout(() => {
            this.roleUpdated.emit();
            this.closeAddRole.emit(true);
          }, 1500);
        }
        this.saveBtnLoading = false;
      },
      error: (_err) => {
        this.saveBtnLoading = false;
      }
    });
  }

  addRoles() {
    this.saveBtnLoading = true;    
    let secureFormValue = this.sharedService.getSecurePayload(this.orderForm.value);
    const createJobRolePayload = {
      name: secureFormValue.roleName,
      role_type_id: this.roleTypeList.find((mode:any) => mode.label === this.orderForm.value.roleType)?.value,
      requirement: secureFormValue.requirement,
      description: (this.orderForm.value.roleDescription || '')
        .replace(/^[\s\n\r]+/, '')
        .replace(/[\s\n\r]+$/, '')
        .replace(/^\s*(<p>&nbsp;<\/p>|\s)*/, '')
        .trim(),
      attachment: this.orderForm.value.attachment,
      work_mode: this.workModeList.find(mode => mode.label === this.orderForm.value.remoteJob)?.value,
      locations: this.orderForm.value.locationInformation.map((each: any) => ({
        country: each.country ? each.country : '',
        state: each.state ? each.state : '',
        city: each.city ? Array.isArray(each.city) ? each.city : [each.city] : [],
        business_unit: this.sharedService.sanitizeInput(each.businessUnit),
        opening: each.openings ? each.openings : 0,
        max_applicant: each.maximumApplicants || 0,
        diversity_male: each.maleDiversity || 0,
        diversity_female: each.femaleDiversity || 0,
        diversity_other: each.otherDiversity || 0,
      })),
    };
    this.roleService.createJobRolesFastApi(createJobRolePayload).subscribe({
      next: (response) => {
        if (response.status === 201) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail,
          });
          this.orderForm.reset();
          this.mediaBase64 = '';
          this.attachmentName = null;
          this.mediaFile = [];
          tinymce.activeEditor.setContent('');
          this.clicked = false;
          setTimeout(() => {
            this.closeAddRole.emit(true);
          }, 1500);
        }
        this.saveBtnLoading = false;
      },
      error: (_err) => {
        this.saveBtnLoading = false;
      }
    });
  }

  removeItem(i: number) {
    this.locationInformation.removeAt(i);
  }

  onSelectMedia(event: any) {
    this.mediaFile = event.addedFiles;
    this.handleUpload(event);
  }

  onRemoveMedia(event: any) {
    this.mediaFile.splice(this.mediaFile.indexOf(event), 1);
    this.attachmentName = null;
  }

  onSave() { }

  handleUpload(event: any) {
    const file = event.addedFiles[0];
    if (!file) {
      console.error('No file selected');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'File size should be less than 2MB'
      });
      return;
    }

    const fileName = this.generateFileName(file);
    const renamedFile = new File([file], fileName, { type: file.type });
    const filePath = `temp/${this.companyId}/${fileName}`;

    const payload = {
      file_path: filePath,
      bucket_type: 'public',
      origin:"job_role_creation",
    };

    this.uploadingFile = true;
    this.fileUploadService.getSignedUrlGCS(payload).subscribe({
      next: (response: any) => {
        if (response && response.body.signed_url) {
          this.uploadFileToGCS(response.body.signed_url, renamedFile, filePath, fileName);
        }
      },
      error: (error) => {
        console.error('Error getting signed URL:', error);
        this.uploadingFile = false;
      }
    });
  }

  private generateFileName(file: any): string {
    let fileName = file.name.split(".");
    let fileExtension = fileName.pop();
    const timestamp = new Date().getTime();
    return `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
  }

  uploadFileToGCS(signedUrl: string, file: any, filePath: string, filename: string) {
    this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
      next: (response: any) => {
        if (response && response.status === "success") {
          this.attachmentName = filename;
          this.uploadingFile = false;
        }
      },
      error: (error) => {
        console.error('Error uploading file to GCS:', error);
        this.uploadingFile = false;
      }
    });
  }
  
  updateLocationDetails(key: any, index: number, value: any) {
    this.locationInformation.at(index).patchValue({
      [key]: value,
    });
  }

  updateHiringManagerDetails(key: any, index: number, value: any) {
    this.locationInformation.at(index).patchValue({
      [key[0]]: value.name,
      [key[1]]: value.id,
    });
  }
  async loadTinyMce() {
    await this.globalService.loadScript(
      'script',
      `https://cdn.tiny.cloud/1/${this.tinymce_api_key}/tinymce/8.0.2/tinymce.min.js`,
      'text/javascript',
      'examlyck'
    );
    tinymce.remove();
    tinymce
      .init({
        selector: 'textarea[formControlName="roleDescription"]',
        content_style:
          "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap'); body { font-family: Poppins; }",
        height: 500,
        content_css_cors: true,
        content_css: true,
        menu: '',
        plugins: 'preview searchreplace autolink directionality code visualblocks visualchars fullscreen link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help quickbars emoticons save autoresize image',
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl',
        toolbar_sticky: true,
        branding :false,
        images_upload_url: '',
        image_caption: true,
        quickbars_selection_toolbar:
          'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        toolbar_mode: 'wrap',
        contextmenu: 'link image imagetools table',
        relative_urls: false,
        convert_urls: false,
        min_height: 500,
        max_height: 500,
        autoresize_bottom_margin: 0,
        autoresize_overflow_padding: 0,
        setup: (editor: any) => {
          editor.on('init', () => {
            // editor.getBody().style.paddingTop = '1.25rem';
            this.showEditor = true;
            this.loadingSpinner = false;
            
            if (this.data && this.isUpdate) {
              this.setRoleDetails(this.data);
            } else {
              this.addItem();
            }
          });
        }
      });
  }
  viewCountry()
  {
    setTimeout(() => {
      let el: any = this.countryDiv.nativeElement;
      el.click();
      }, 200);
  }
  viewState()
  {
    setTimeout(() => {
      let el: any = this.stateDiv.nativeElement;
      el.click();
      }, 200);
  }
  viewCity()
  {
    setTimeout(() => {
      let el: any = this.cityDiv.nativeElement;
      el.click();
      }, 200);
  }
  
  viewRole()
  {
    setTimeout(() => {
      let el: any = this.roleTypeDiv.nativeElement;
      el.click();
      }, 200);
  }

  viewRemote()
  {
    setTimeout(() => {
      let el: any = this.remoteDiv.nativeElement;
      el.click();
      }, 200);
  }
  
  viewManager()
  {
    setTimeout(() => {
      let el: any = this.hiringManagerDiv.nativeElement;
      el.click();
      }, 200);
  }
  clearFormData() {
    this.orderForm.reset();
    this.selectedRoleType = '';
    this.selectedRemote = '';
    this.locationInformation.clear();
    this.locationOptions = [];
    this.selectedCountries = [];
    this.selectedStates = [];
    this.selectedCities = [];
    this.mediaFile = [];
    this.attachmentName = null;
    this.mediaBase64 = '';    
    if (tinymce.activeEditor) {
      tinymce.activeEditor.setContent('');
    }
  }
  
}
